import React, { useEffect, useState } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Row,
  Col,
  Input,
} from "antd";

import { formItemLayout, tailFormItemLayout } from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
  onUpdateSubmit,
} from "../../utils/form_utilities";
import { authenticateAdmin } from "../../utils/authentications";
import { DISCOUNT_TYPE_VALUE } from "../../utils/constants";
import {
  onBranchSearch,
  onCategorySearch,
  onTieupSearch,
  onWarehouseSearch,
} from "./../../utils/utilities";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import {
  dealer_price_tag_options,
  discount_type_options,
  voucher_discount_options,
} from "../../utils/Options";
import numberFormat from "../../utils/numberFormat";
import moment from "moment";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import CalendarSelectFieldGroup from "../../commons/CalendarSelectFieldGroup";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import TimePickerFieldGroup from "../../commons/TimePickerFieldGroup";

const { Content } = Layout;

const url = "/api/discounts/";
const title = "Discounts";

const initialValues = {
  _id: null,
  name: "",
  discount: "",
  discount_type: "",
  min_order_amount: "",
  discount_cap: "",
  sharing_rate: "",
  period_covered: [],
  tieup: null,
  is_with_voucher_no: false,
  for_non_promo_items: false,
  deleted: undefined,
  start_time: null,
  end_time: null,
};

const date_fields = [];
const period_covered_fields = ["period_covered"];
export default function DiscountForm({ history }) {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);

  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    tieups: [],
  });

  const records_column = [
    {
      title: "Branch",
      dataIndex: ["branch", "name"],
    },
    {
      title: "Voucher/Disc",
      dataIndex: "is_voucher_or_discount",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Disc.",
      dataIndex: "discount",
      render: (value, record) =>
        value && record.discount_type === DISCOUNT_TYPE_VALUE
          ? numberFormat(value)
          : `${numberFormat(value)}%`,
    },

    {
      title: "Type.",
      dataIndex: "discount_type",
    },

    {
      title: "Min. Order Amount",
      dataIndex: "min_order_amount",
      render: (value) => value && numberFormat(value),
    },

    {
      title: "Disc. Cap",
      dataIndex: "discount_cap",
      render: (value) => value && numberFormat(value),
    },

    {
      title: "Tieup",
      dataIndex: ["tieup", "name"],
    },

    {
      title: "Sharing Rate",
      dataIndex: "sharing_rate",
      align: "center",
      render: (value) => value && numberFormat(value),
    },

    {
      title: "Categories",
      dataIndex: ["categories"],
      render: (categories) => (categories || []).map((o) => o.name).join(", "),
    },

    {
      title: "W/ Voucher No.",
      dataIndex: "is_with_voucher_no",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },
    {
      title: "W/ Auth.",
      dataIndex: "is_with_authentication",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },

    {
      title: "For Non Promo",
      dataIndex: "for_non_promo_items",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },

    {
      title: "Included at POS",
      dataIndex: "is_included_at_pos",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },

    {
      title: "Seq",
      dataIndex: "sequence",
      align: "center",
      width: 100,
      render: (value, record) => (
        <Input
          defaultValue={value}
          className="table-input-sequence"
          onBlur={(e) => {
            onUpdateSubmit({
              url,
              state: record,
              form_data: { sequence: e.target.value },
              additional_url: "sequence",
            });
          }}
        />
      ),
    },

    {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <span
          onClick={() =>
            edit({
              record,
              setErrors,
              setRecords,
              url,
              setState,
              date_fields,
              period_covered_fields,
            })
          }
        >
          <i className="fas fa-edit"></i>
        </span>
      ),
    },
  ];

  useEffect(() => {
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              setRecords([]);
              setState({ ...initialValues, date: moment() });
            }}
          />
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: state,
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                period_covered_fields,
              });
            }}
            initialValues={initialValues}
          >
            <SelectFieldGroup
              label="Branch"
              name="branch"
              value={state.branch?.name}
              onChange={(index) => {
                onChange({
                  key: "branch",
                  value: options.branches?.[index] || null,
                  setState,
                });
              }}
              onSearch={(value) => onBranchSearch({ value, setOptions })}
              error={errors.branch}
              formItemLayout={formItemLayout}
              data={options.branches}
            />

            <SimpleSelectFieldGroup
              label="Disc/Voucher"
              name="is_voucher_or_discount"
              value={state.is_voucher_or_discount}
              onChange={(value) => {
                onChange({
                  key: "is_voucher_or_discount",
                  value,
                  setState,
                });
              }}
              error={errors.is_voucher_or_discount}
              options={voucher_discount_options}
              formItemLayout={formItemLayout}
            />

            <TextFieldGroup
              label="Name"
              name="name"
              error={errors.name}
              formItemLayout={formItemLayout}
              value={state.name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <TextFieldGroup
              type="number"
              step={0.01}
              label="Discount"
              name="discount"
              error={errors.discount}
              formItemLayout={formItemLayout}
              value={state.discount}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <TextFieldGroup
              label="Sequence"
              name="sequence"
              error={errors.sequence}
              formItemLayout={formItemLayout}
              value={state.sequence}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <SimpleSelectFieldGroup
              label="Disc. Type"
              name="discount_type"
              value={state.discount_type}
              onChange={(value) => {
                onChange({
                  key: "discount_type",
                  value,
                  setState,
                });
              }}
              error={errors.discount_type}
              options={discount_type_options}
              formItemLayout={formItemLayout}
            />

            <SelectFieldGroup
              label="Tieup"
              name="tieup"
              value={state.tieup?.name}
              onChange={(index) => {
                onChange({
                  key: "tieup",
                  value: options.tieups?.[index] || null,
                  setState,
                });
              }}
              onSearch={(value) => onTieupSearch({ value, setOptions })}
              error={errors.tieup}
              formItemLayout={formItemLayout}
              data={options.tieups}
            />

            <TextFieldGroup
              type="number"
              step={0.01}
              label="Min. Order Amount"
              name="min_order_amount"
              error={errors.min_order_amount}
              formItemLayout={formItemLayout}
              value={state.min_order_amount}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              help="Leave blank for no minimum order amount"
            />

            <TextFieldGroup
              type="number"
              step={0.01}
              label="Disc. Cap."
              name="discount_cap"
              error={errors.discount_cap}
              formItemLayout={formItemLayout}
              value={state.discount_cap}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              help="Leave blank for no discount capping"
            />

            <TextFieldGroup
              type="number"
              step={0.01}
              label="Sharing Rate"
              name="sharing_rate"
              error={errors.sharing_rate}
              formItemLayout={formItemLayout}
              value={state.sharing_rate}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              help="Leave blank for no sharing discount"
            />

            <SelectFieldGroup
              label="Category"
              name="category"
              value={null}
              onChange={(index) => {
                const category = options.categories?.[index];

                if (category) {
                  setState((o) => ({
                    ...o,
                    categories: [...(o.categories || []), category],
                  }));
                }
              }}
              onSearch={(value) => onCategorySearch({ value, setOptions })}
              error={errors.category}
              formItemLayout={formItemLayout}
              data={options.categories}
            />

            <Row>
              <Col span={20} offset={4}>
                <table>
                  <tbody>
                    {(state.categories || []).map((o, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <span
                              className="fas fa-trash"
                              onClick={() => {
                                onDeleteItem({
                                  field: "categories",
                                  index: i,
                                  setState,
                                });
                              }}
                            />
                          </td>
                          <td className="p-l-1">{o.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Col>
            </Row>

            <CalendarSelectFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) => {
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }));
              }}
              error={errors.period_covered}
              formItemLayout={formItemLayout}
              help="Leave blank if applicable anytime"
            />

            {/* <TimePickerFieldGroup
              label="Start Time"
              name="start_time"
              value={state.start_time || null}
              onChange={(value) =>
                setState((o) => ({ ...o, start_time: value }))
              }
              error={errors.start_time}
              formItemLayout={formItemLayout}
              showTime={true}
            />

            <TimePickerFieldGroup
              label="End Time"
              name="end_time"
              value={state.end_time || null}
              onChange={(value) => setState((o) => ({ ...o, end_time: value }))}
              error={errors.end_time}
              formItemLayout={formItemLayout}
              showTime={true}
            /> */}

            <CheckboxFieldGroup
              label="Is GC"
              name="is_gc"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.is_gc}
              checked={state.is_gc}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="Taxable"
              name="taxable"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.taxable}
              checked={state.taxable}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="w/ Voucher No."
              name="is_with_voucher_no"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.is_with_voucher_no}
              checked={state.is_with_voucher_no}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="w/ Authentication"
              name="is_with_authentication"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.is_with_authentication}
              checked={state.is_with_authentication}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="For Non-Promo Items"
              name="for_non_promo_items"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.for_non_promo_items}
              checked={state.for_non_promo_items}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="Included at POS"
              name="is_included_at_pos"
              error={errors.is_included_at_pos}
              formItemLayout={formItemLayout}
              checked={state.is_included_at_pos}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {isEmpty(state.deleted) && (
              <Form.Item className="m-t-1" {...tailFormItemLayout}>
                <div className="field is-grouped">
                  <div className="control">
                    <button className="button is-small is-primary">Save</button>
                  </div>
                  {!isEmpty(state._id) ? (
                    <span
                      className="button is-danger is-outlined is-small"
                      onClick={() => {
                        onDelete({
                          id: state._id,
                          url,
                          user: auth.user,
                        });
                        setState({ ...initialValues, date: moment() });
                      }}
                    >
                      <span>Delete</span>
                      <span>
                        <i className="fas fa-times"></i>
                      </span>
                    </span>
                  ) : null}
                </div>
              </Form.Item>
            )}
          </Form>
        ) : (
          <Table
            dataSource={records}
            columns={records_column}
            rowKey={(record) => record._id}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page) =>
                onSearch({
                  page,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                }),
              total: total_records,
              pageSize: 60,
            }}
          />
        )}
      </div>
    </Content>
  );
}
